import { ITasksCountWidgetProps } from "./TasksCountWidget.tsx";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider.tsx";
import { DashboardTaskOverviewViewModel } from "../taskOverviewWidget/TaskOverviewWidget.types.ts";
import { NavigationMenuItem } from "../../navigationMenuSettings/NavigationMenuSettings.types";
import { isNavigationMenuItemHidden } from "../../navigationMenuSettings/navigationMenuItems";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useTasksCountWidget(props: ITasksCountWidgetProps) {
    const userContext = useUserContext();
    const isEnabled =
        userContext.permissions.taskPermissions.read && !isNavigationMenuItemHidden(userContext.hiddenNavigationMenuItems, NavigationMenuItem.Tasks);

    const url = `/taskManagement/dashboard/tasksCount?year=${new Date().getFullYear()}&onlyUserSpecific=${props.onlyUserSpecific}&groupentityid=${props.selectedGroupCompany}`;
    const { isLoading, data } = useDotLegalQuery<DashboardTaskOverviewViewModel>(url, {
        enabled: isEnabled,
    });

    return {
        isLoading,
        data,
        isEnabled,
    };
}
